var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { injectIntl } from "@irati/utils/lang";
import Button from "@irati/ui/src/Button";
import Loading from "@irati/ui/src/Loading";
import idHelper from "@irati/utils/id";
import Flex from "@irati/ui/src/Flex";
import CheckboxOption from "../CheckboxOption";
import { Container, StyledHr, OptionsWrapper } from "./styled";
var Div = function (props) { return React.createElement("div", __assign({}, props)); };
var CheckboxGroup = /** @class */ (function (_super) {
    __extends(CheckboxGroup, _super);
    function CheckboxGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shouldAllOptionBeChecked = function () {
            var options = _this.props.options;
            return !options || options.filter(function (option) { return option.isChecked; }).length === options.length;
        };
        return _this;
    }
    CheckboxGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, loadFilterOptions = _a.loadFilterOptions, options = _a.options, allOptionText = _a.allOptionText, isAllOptionChecked = _a.isAllOptionChecked, resetButtonText = _a.resetButtonText, saveButtonText = _a.saveButtonText, disableResetButton = _a.disableResetButton, disableSaveButton = _a.disableSaveButton, onSelect = _a.onSelect, onSelectAll = _a.onSelectAll, onReset = _a.onReset, onSave = _a.onSave, useExpand = _a.useExpand, id = _a.id;
        var Wrapper = useExpand ? Container : Div;
        return (React.createElement(Wrapper, { id: id },
            React.createElement(OptionsWrapper, null,
                React.createElement(CheckboxOption, { id: idHelper("select-all", this.props), value: "select-all", name: allOptionText, checked: isAllOptionChecked ? isAllOptionChecked() : this.shouldAllOptionBeChecked(), onClick: onSelectAll }),
                options &&
                    options.map(function (_a, i) {
                        var uuid = _a.uuid, name = _a.name, value = _a.value, isChecked = _a.isChecked;
                        return (React.createElement(CheckboxOption, { id: idHelper("option-" + (i + 1), _this.props), key: uuid, value: value, name: name, checked: isChecked, onClick: onSelect }));
                    })),
            React.createElement(StyledHr, null),
            React.createElement(Flex, { marginTop: true, marginBottom: true, padding: 1 / 2, justifyContent: "flex-end", alignItems: "center" },
                React.createElement(Button, { small: true, tertiary: true, disabled: disableResetButton, onClick: onReset, marginRight: true }, resetButtonText),
                React.createElement(Button, { small: true, disabled: disableSaveButton, primary: true, onClick: onSave }, saveButtonText)),
            React.createElement(Loading, { load: loadFilterOptions, useLoader: false })));
    };
    CheckboxGroup.defaultProps = {
        id: "checkbox-group"
    };
    return CheckboxGroup;
}(Component));
export default injectIntl(CheckboxGroup);
